`<template>
  <div id="slate-int-calculator">
    <div class="calculator-main">
      <default-container v-show="!showMethodology">
        <calculator-input v-show="state <= 1" :field-groups="fieldGroups" v-on:submitData="getResult">
          <span slot="title">{{ title }}</span>
          <span slot="button">{{ buttonText }}</span>
        </calculator-input>
        <calculator-output v-on:goBack="resetState" v-on:resultRendered="showResult" v-show="state == 2" :field-groups="fieldGroups" :state="state" :result="result" :render-func="renderFunc"></calculator-output>
      </default-container>
      <default-container class="methodology-container" v-show="showMethodology">
        <calculator-methodology v-on:goBack="toggleMethodology">
          <div v-html="methodology"></div>
        </calculator-methodology>
      </default-container>
    </div>
    <div class="methodology-button-container">Interactive by Andrew Kahn | <span @click="toggleMethodology" class="methodology-button">Methodology</span></div>
  </div>
</template>

<script>
import configData from './assets/Data'
import processFunc from './assets/Process'
import renderFunc from './assets/Render'
import DefaultContainer from '../../slate-int-default-container/src/DefaultContainer'
import CalculatorInput from './components/CalculatorInput'
import CalculatorTransition from './components/CalculatorTransition'
import CalculatorOutput from './components/CalculatorOutput'
import CalculatorMethodology from './components/CalculatorMethodology'

export default {
  name: 'Calculator',
  data () {
    return configData
  },
  methods: {
    renderFunc,
    getResult () {
      this.state = 1
      this.result = processFunc(this.fieldGroups)
    },
    showResult () {
      this.state = 2
    },
    resetState () {
      this.state = 0
      this.reset = true
    },
    toggleMethodology () {
      this.showMethodology = !this.showMethodology
    }
  },
  components: {
    'default-container': DefaultContainer,
    'calculator-input': CalculatorInput,
    'calculator-transition': CalculatorTransition,
    'calculator-output': CalculatorOutput,
    'calculator-methodology': CalculatorMethodology
  }
}
</script>

<style scoped>
#slate-int-calculator {
  position: relative;
}
.calculator-main {
  position: relative;
}
.methodology-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.methodology-button-container {
  margin-top: 0.2em;
  text-align: right;
  color: #888;
  font-size: 0.8em;
}
.methodology-button {
  cursor: pointer;
  position: relative;
}
.methodology-button:active {
  top: 1px;
}
</style>



// WEBPACK FOOTER //
// Calculator.vue?77248b9b